import { render, staticRenderFns } from "./Fornecedores.vue?vue&type=template&id=0545847c&scoped=true"
import script from "./Fornecedores.vue?vue&type=script&lang=ts"
export * from "./Fornecedores.vue?vue&type=script&lang=ts"
import style0 from "./Fornecedores.vue?vue&type=style&index=0&id=0545847c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0545847c",
  null
  
)

export default component.exports